import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { baseUrl } from 'libs/core/src/lib/configs/baseUrl';
import { IUsersService } from 'libs/core/src/lib/services/users.service';
import { RepresentativeService } from 'libs/core/src/lib/services/representative.service';
import {
  createQueryParams,
  InsurerPermissions,
  IRepresentative,
  IRepresentativeRequest,
  IUserQueryParams,
  PaginatedResponse,
} from '@inshuwa-client/models';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class InsurerUsersService implements IUsersService {
  private http = inject(HttpClient);
  private rep = inject(RepresentativeService);

  updatePermissions(
    userId: number,
    request: Partial<InsurerPermissions>,
  ): Observable<InsurerPermissions> {
    return this.http.put<InsurerPermissions>(
      `${baseUrl()}/users/${userId}/permissions/insurer`,
      request,
    );
  }

  getPermissions(userId: number): Observable<InsurerPermissions> {
    return this.http.get<InsurerPermissions>(
      `${baseUrl()}/users/${userId}/permissions/insurer`,
    );
  }

  addUser(user: Partial<IRepresentativeRequest>): Observable<IRepresentative> {
    const insurerId = this.rep.getLoggedInInsurerRepresentative().insurerId;
    return this.http.post<IRepresentative>(
      `${baseUrl()}/insurers/${insurerId}/representatives`,
      user,
    );
  }

  getUsers(
    queryParams: Partial<IUserQueryParams>,
  ): Observable<PaginatedResponse<IRepresentative>> {
    const insurerId = this.rep.getLoggedInInsurerRepresentative().insurerId;
    return this.http.get<PaginatedResponse<IRepresentative>>(
      `${baseUrl()}/insurers/${insurerId}/representatives`,
      { params: createQueryParams(queryParams) },
    );
  }
}
